<template>
    <div ref="containerDemand">
        <div class="d-flex justify-space-between align-center">
            <span class="title">
                <v-icon>list</v-icon>
                {{ $t('common.timeline.componentName') }}
            </span>
            <v-spacer></v-spacer>
            <timeline-filter v-if="!newDemand" @filter-timeline="loadData"/>
            <v-btn
                v-if="setup.showUpdate"
                :loading="loading"
                :disabled="loading"
                color="purple"
                :dark="!loading"
                @click.prevent="loadData(filters, true)"
                class="ml-1"
            >
                <v-icon>refresh</v-icon>
            </v-btn>
        </div>
        <v-progress-linear :indeterminate="true" v-show="loading" class="mt-2"></v-progress-linear>
        <!-- <v-card-text id="timeline-container" v-show="!loading" class="timeline-container" :style="{ marginBottom: marginBottom + 'px' }"> -->
        <v-card-text id="timeline-container" class="timeline-container" :style="{ marginBottom: marginBottom + 'px' }">
            <v-timeline align-top dense>
                <v-timeline-item
                    v-for="(item, index) in interaction.results"
                    :key="index"
                    :color="item.note.responsible ? item.note.responsible.profile.color : '#F2C511'"
                    small
                    fill-dot
                >
                    <template v-slot:icon>
                        <v-avatar size="30" :color="item.note.responsible ? item.note.responsible.user.name  : item.note.clientResponsible.name">
                            <span class="white--text avatar--letter">{{ item.note.responsible ? item.note.responsible.user.name  : item.note.clientResponsible.name | initialName }}</span>
                        </v-avatar>
                    </template>

                    <v-card class="elevation-2">
                        <v-card-title class="subtitle-2" v-if="setup.timeline.className === 'Employee'"><v-icon size="14" class="mr-1" v-show="!item.note.isPublic">lock</v-icon>{{ item.note.interaction }} - {{ item.note.client.name }}{{ (item.note.demand)? ' - ' + item.note.demand.demand : '' }} - {{ item.note.correctDate | momentFormatDate("dddd, D MMMM YYYY") }}</v-card-title>
                        <v-card-title class="subtitle-2" v-else-if="setup.timeline.className === 'Client'"><v-icon size="14" class="mr-1" v-show="!item.note.isPublic">lock</v-icon>{{ item.note.interaction }}{{ (item.note.demand) ? ' - ' + item.note.demand.demand : '' }} - {{ item.note.responsible.name }} - {{ item.note.correctDate | momentFormatDate("dddd, D MMMM YYYY") }}</v-card-title>
                        <v-card-title class="subtitle-2" v-else><v-icon size="14" class="mr-1" v-show="!item.note.isPublic">lock</v-icon>{{ item.note.interaction }} - {{ item.note.responsible ? item.note.responsible.user.name  : item.note.clientResponsible.name }} - {{ item.note.correctDate | momentFormatDate("dddd, D MMMM YYYY") }}</v-card-title>
                        <v-card-text>
                            <read-only class="body-2" :text="item.note.annotation" />
                            <div v-if="setup.isEdit">
                                <v-row v-if="item.files && item.files.length > 0">
                                    <v-col cols="3" v-for="f in item.files" :key="f.objectId">
                                        <file-info :file="f.file" :id="f.objectId" :type="'interaction'" :clearFile="clearFile"/>
                                    </v-col>
                                </v-row>
                            </div>
                            <div v-else>
                                <v-row v-if="item.files && item.files.length > 0">
                                    <v-col cols="3" v-for="f in item.files" :key="f.objectId">
                                        <file-info :file="f.file" :type="'interaction'" :clearFile="clearFile"/>
                                    </v-col>
                                </v-row>
                            </div>
                        </v-card-text>
                        <v-card-actions class="pb-0 pt-0">
                            <v-spacer></v-spacer>
                            <v-btn
                                v-if="
                                    (item.note.category === 5 && setup.isAdmin === true) ||
                                    (item.note.category !== 5 && setup.isEmployee === true)
                                "
                                color="error"
                                text
                                small
                                @click.prevent="deleteActivity (index, item)"
                            >
                                {{ $t('common.remove') }}
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-timeline-item>
            </v-timeline>
            <v-col cols="12" class="text-right">
                <v-btn
                    v-if="hasMoreInteractions"
                    :loading="loading"
                    :disabled="loading"
                    @click="loadData(filters, null)"
                    small
                    text
                >
                    {{ $t('common.loadMore') }}
                    <span slot="loader" class="custom-loader">
                        <v-icon light>cached</v-icon>
                    </span>
                </v-btn>
            </v-col>
        </v-card-text>
        <div id="editor-textarea-container" ref="editorTextareaContainer" class="editor-textarea-container">
            <v-form
                ref="formActivity"
                v-model="activity.valid"
                lazy-validation
            >
                <v-container>
                    <v-row v-show="editorFocus" v-if="isEmployee">
                        <v-col cols="3" >
                            <input-select :setup.sync="category"></input-select>
                        </v-col>
                        <v-col cols="4">
                            <input-date-picker :setup.sync="activity.datePickers.correctDate"></input-date-picker>
                        </v-col>
                        <v-col cols="2" >
                            <v-checkbox
                                v-model="activity.item.isPrivate"
                                :label="$t('demand.form.timeline.isPrivate')"
                                data-id="id"
                            ></v-checkbox>
                        </v-col>
                    </v-row>
                    <v-row v-if="editorFocus && (previewFiles && previewFiles.length > 0)" class="file-container">
                        <v-col cols="4" v-for="f in previewFiles" :key="f.index">
                            <file-info :file="f.file" :type="'interaction'" :clearFile="clearFile"/>
                        </v-col>
                    </v-row>
                    <v-row v-if="editorFocus && (previewFiles && previewFiles.length > 0)">
                        <v-col cols="12" class="overline">{{ $t('demand.form.timeline.totalFiles') }} {{ previewFiles.length }}</v-col>
                    </v-row>
                    <editor v-model="activity.item.annotation" :button="saveActivity" :files="addInteractionFiles" :focus.sync="editorFocus" :key="componentKey"/>
                </v-container>
            </v-form>
        </div>
    </div>
</template>

<script>
import API from '@/api'
import ReadOnly from '@/components/ReadOnly'
import TimelineFilter from '@/components/TimelineFilter'
import FileInfo from '@/components/FileInfo'
import Editor from '@/components/Editor'
import InputSelect from '@/components/InputSelect'
import InputDatePicker from '@/components/InputDatePicker'

export default {
    name: 'demand-timeline',
    components: {
        ReadOnly,
        TimelineFilter,
        FileInfo,
        Editor,
        InputSelect,
        InputDatePicker
    },
    props: ['setup', 'demand'],
    data: function () {
        return {
            componentKey: 0,
            elmFather: null,
            newDemand: true,
            elmTimeline: null,
            loading: false,
            fileLoading: false,
            previewFiles: [],
            filters: [],
            skip: 0,
            interaction: {
                count: 0,
                results: []
            },
            activity: {
                dialog: false,
                valid: false,
                datePickers: {
                    correctDate: {
                        label: this.$t('demand.form.timeline.correctDate.label'),
                        rule: [
                            v => !!v || this.$t('demand.form.timeline.correctDate.rule')
                        ],
                        required: true,
                        readonly: false,
                        filled: true,
                        dateFormatted: undefined
                    }
                },
                item: {
                    demand: undefined,
                    annotation: undefined,
                    files: [],
                    category: 1,
                    isPrivate: false,
                    correctDate: ''
                }
            },
            category: {
                label: this.$t('common.timeline.category.label'),
                text: 'label',
                value: 'value',
                icon: 'comment',
                required: true,
                readonly: false,
                filled: true,
                multiple: false,
                rule: [
                    v => !!v || this.$t('common.timeline.category.rule')
                ],
                items: [
                    { value: 1, label: this.$t('common.timeline.category.items.noteFile') },
                    { value: 2, label: this.$t('common.timeline.category.items.meeting') },
                    { value: 3, label: this.$t('common.timeline.category.items.phone') },
                    { value: 4, label: this.$t('common.timeline.category.items.email') },
                    { value: 6, label: this.$t('common.timeline.category.items.charge') }
                ],
                selectedItems: 1
            },
            editorFocus: false,
            marginBottom: 60
        }
    },
    watch: {
        'demand.interaction.results': {
            handler: function (val, oldVal) {
                this.interaction.count = this.demand.interaction.count
                this.interaction.results = this.demand.interaction.results
                this.$forceUpdate()
            },
            deep: true
        },
        'setup.timeline.loadData': {
            handler: function (val, oldVal) {
                if (oldVal !== val && val) {
                    this.loadData(this.filters, true)
                }
            },
            deep: true
        },
        'editorFocus': {
            handler: function (val, oldVal) {
                if (oldVal !== val) {
                    if (val) {
                        this.marginBottom = 285
                    } else {
                        this.marginBottom = 60
                    }
                }
            },
            deep: true
        }
    },
    created () {
        this.$eventHub.$on('handleFocus', this.handleFocus)
    },
    beforeDestroy () {
        this.$eventHub.$off('handleFocus')
    },
    mounted () {
        this.activity.datePickers.correctDate.dateFormatted = this.$options.filters.moment(undefined, 'America/Sao_Paulo', 'L')
        this.elmTimeline = document.getElementById('timeline-container')
        this.elmFather = document.getElementById('editor-textarea-container')
        this.interaction.results = this.demand.interaction.results
        if (this.setup.timeline.loadData !== false) {
            this.loadData(this.filters, true)
        }
        this.newDemand = !this.$route.params.id
    },
    computed: {
        isEmployee: function () {
            return this.setup.isEmployee
        },
        hasMoreInteractions () {
            if (this.demand.interaction === undefined || this.demand.interaction.length === 0) return
            return (this.interaction.results.length < this.interaction.count)
        }
    },
    methods: {
        loadData (filters = null, refresh = null, skip = null, limit = null) {
            this.loading = true
            window.getApp.disableClientNavigation = true
            this.filters = (filters) || []

            if (refresh) {
                this.interaction.count = 0
                skip = 0
            } else {
                skip = this.interaction.results.length
            }

            let endpoint = API.EndPoints.getInteractions
            let params = {
                filters: this.filters,
                className: this.setup.timeline.className,
                objectId: (this.setup.timeline.className !== 'Demand') ? this.$route.params.id : this.demand.objectId,
                limit: limit || 15,
                skip: skip
            }

            const currentUserCompanyObjectId = JSON.parse(localStorage.currentUserCompany).client.objectId
            if (
                (this.demand.department && this.demand.department.objectId === currentUserCompanyObjectId) ||
                this.demand.owner.objectId !== currentUserCompanyObjectId
            ) {
                params.isPublic = true
            }

            new API(endpoint, params).request().then(response => {
                this.interaction.count = response.data.result.count
                if (refresh) {
                    this.interaction.results = []
                }
                this.interaction.results = [...this.interaction.results, ...response.data.result.results]
                this.loading = false
                this.setup.timeline.loadData = false

                window.getApp.disableClientNavigation = false
            }, (e) => {
                this.$helpers.requestError(e)
            })
        },
        async addInteractionFiles (value) {
            for (let i = 0; event.target.files.length > i; i++) {
                const file = event.target.files[i]
                const tempFile = file.slice(0, file.size)
                const newFile = new File([tempFile], file.name.replace(/[^a-zA-Z._0-9]/g, ''))

                this.previewFiles.push({ file: newFile })
            }
        },
        clearFile (value) {
            if (!value) {
                this.loadData(this.filters, true)
            } else {
                if (this.previewFiles.length > 0) {
                    this.previewFiles = this.previewFiles.filter((f) => f.file.name !== value)
                } else {
                    this.demand.files = this.demand.files.filter((f) => f.file.name !== value)
                }
            }
        },
        async uploadInteractionFile () {
            for (let index = 0; index < this.previewFiles.length; index++) {
                this.fileLoading = true
                let endpoint = API.EndPoints.upload
                endpoint.filename = this.$helpers.normalizeFilename(this.previewFiles[index].file.name)

                await new API(endpoint, this.previewFiles[index].file).request()
                    .then(response => {
                        const file = response.data
                        file.__type = 'File'
                        this.activity.item.files.push(file)
                        this.fileLoading = false
                    })
                    .catch(() => { alert(this.$t('demand.form.timeline.errors.save')) })
            }
        },
        async saveActivity () {
            if (this.$refs.formActivity.validate()) {
                if (!this.setup.isEdit) {
                    await this.addActivity()
                } else {
                    await this.addActivityRest()
                }
            }
            return false
        },
        async addActivity () {
            const currentUserCompany = JSON.parse(localStorage.getItem('currentUserCompany'))
            const files = []

            for (let index = 0; index < this.previewFiles.length; index++) {
                const element = this.previewFiles[index]
                files.push(element)
            }

            let items = {
                note: {
                    annotation: this.activity.item.annotation,
                    isPrivate: this.activity.item.isPrivate,
                    responsible: currentUserCompany
                },
                files: files
            }

            items.note.category = this.category.selectedItems
            const category = this.category.items.filter((element) => {
                return element.value === this.category.selectedItems
            })
            items.note.interaction = category[0].label

            const newDateFormatted = this.$helpers.getFormattedDate(this.activity.datePickers.correctDate.dateFormatted)
            items.note.correctDate = newDateFormatted

            this.demand.interaction.results.push(items)
            this.activity.item.annotation = undefined
            this.componentKey += 1
        },
        async addActivityRest () {
            if (this.previewFiles.length > 0) {
                await this.uploadInteractionFile()
            }

            let newActivity = this.activity.item

            if ((!newActivity.annotation || newActivity.annotation === '<p></p>') && newActivity.files.length === 0) {
                alert(this.$t('demand.form.timeline.errors.commentFile'))
                return
            }
            const currentUserCompany = JSON.parse(localStorage.getItem('currentUserCompany'))

            newActivity.category = this.category.selectedItems
            newActivity.demand = this.$route.params.id
            newActivity.clientId = this.demand.client.objectId

            const newDateFormatted = this.$helpers.getFormattedDate(this.activity.datePickers.correctDate.dateFormatted)

            newActivity.correctDate = newDateFormatted
            newActivity.isEmployee = this.isEmployee
            newActivity.profileId = currentUserCompany.objectId
            newActivity.organizationId = currentUserCompany.client.objectId

            if (this.demand.department !== undefined) {
                newActivity.clientId = this.demand.department.objectId
            }

            let endpoint = API.EndPoints.createInteraction
            new API(endpoint, newActivity).request().then(response => {
                this.btnDisable = false
                this.loadData(this.filters, true)
                this.clearActivity()
                this.activity.item.annotation = undefined
            }, (e) => {
                this.loading = false
                this.$helpers.requestError(e)
                this.clearActivity()
            })
            this.componentKey += 1
        },
        deleteActivity (index, activity) {
            if (confirm()) {
                window.getApp.refreshDemands = true

                if (this.setup.fromDemand) {
                    (!this.setup.isEdit) ? this.removeActivity(index) : this.removeActivityRest(activity)
                } else {
                    this.removeActivityRest(activity)
                }
            }
        },
        async removeActivityRest (interaction) {
            let endpoint = API.EndPoints.deleteInteraction
            endpoint.id = interaction.note.objectId
            let msg = ''
            await new API(endpoint).request()
                .then(
                    (response) => {
                        msg = this.$t('demand.form.timeline.success')
                    },
                    (response) => { msg = (response.status !== 0) ? response.data.error : '' }
                )
            if (msg !== '') alert(msg)
            if (this.$refs.formActivity !== undefined) {
                this.clearActivity()
            }
            this.loadData(this.filters, true)
        },
        removeActivity (index) {
            this.activity.loading = true
            this.demand.interaction.results.splice(index, 1)
            this.activity.loading = false
            this.clearActivity()
        },
        clearActivity () {
            this.activity.valid = false
            this.activity.item.annotation = undefined
            this.activity.datePickers.correctDate.dateFormatted = this.$options.filters.moment(undefined, 'America/Sao_Paulo', 'L')
            this.activity.item.files = []
            this.previewFiles = []
            this.activity.item.isPrivate = false
            this.activity.item.interaction = undefined
            this.activity.loading = false
            this.category.selectedItems = 1
        },
        handleFocus () {
            if (this.editorFocus && !this.elmFather.contains(event.target)) {
                this.editorFocus = false
                if ((!this.activity.item.annotation || this.activity.item.annotation === '<p></p>')) {
                    this.clearActivity()
                }
            }
        }
    }
}
</script>

<style lang="stylus" scoped>
    .editor-textarea-container
        background-color: #f6f8f9
        position: fixed
        width: 100%
        left: 0
        right: 0
        bottom: 0
        outline: none
        z-index: 10

    .file-container
        max-height: 3rem
        overflow-y: scroll
</style>
